<template>
  <v-container>
    <v-row dense align="center" justify="space-between">
      <v-col cols="auto">
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
      <v-col class="text-center">
        <div
          class="text-h4 font-weight-bold text-center"
          style="font-size: clamp(26px, 5vw, 36px); margin-bottom: 12px"
        >
          Costos y Gastos
        </div>
      </v-col>
      <v-col cols="12" class="pb-3">
        <div class="text-h6">Presiona el botón para agregar costos</div>
      </v-col>
      <v-col v-if="user_can.add" cols="12">
        <v-btn router to="/ru/costo" depressed class="primary">
          <v-icon left>mdi-plus</v-icon>
          Agrega Costos
        </v-btn>
      </v-col>
      <v-col cols="12" class="tt">
        <div class="text-h6">Lista de mis costos por actividad y por lugar</div>
        <div class="text-h8">Presione el costo para modificar la información, modificar y/o agregar.</div>
      </v-col>
      <!-- Fila de espaciado -->
      <v-col cols="12" class="py-5"></v-col>
       <!-- Puedes ajustar py-5 a py-3 o py-2 según el espacio que prefieras -->
      <!-- Mensaje si no hay fincas -->
      <v-col v-if="Object.keys(registros).length === 0" cols="12">
        <div class="text-body-1 text-center font-italic">
          Aún no tienes ninguna costo
        </div>
      </v-col>
      <!-- listado de costps en el almacenamiento local -->
      <v-col cols="12" class="lista">
        <v-list three-line>
          <template v-for="registro in registros">
            <form-card
              :key="registro.id"
              :top-text="`Finca • ${getNombreDeFinca(registro.id_finca)}`"
              :top-right-text="registro.fecha"
              :middle-text="parcelaDescription(registro.parcela)"
              :bottom-text="`Ciclo ${registro.ciclo}`"
              :bottom-right-text="producerDescription(registro.productor)"
              :sincronized="registro.sincronizado"
              :opaque="registro.hasOutdatedRecords"
              @click="traerRegistroYNavegar(registro)"
            />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { producerDescription, parcelaDescription } from '@/utilidades'

export default {
  name: 'Costos',
  computed: {
    ...mapState('registros', {
      registros: 'costos',
      fincas: 'fincas',
    }),
    ...mapGetters('registros', ['getNombreDeFinca']),
    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Costos')
  },
  methods: {
    producerDescription,
    parcelaDescription,
    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getCosto', { id: registro.id })
      }
      this.$router.push(`/ru/costo/${registro.id}`)
    },
  },
}
</script>
<style>
  .tt {
    margin-top: 40px;
    margin-bottom: -20px;
  }
  .lista {
    margin-top: 20px;
  }
</style>
